import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Formik, useFormik } from "formik";
import axios from "axios";
import { LoginUserForm } from "./Forms/forms";
import { RegisterUserForm } from "./Forms/forms";
import { useGlobalState } from "./GlobalContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faGlobe } from "@fortawesome/pro-regular-svg-icons";
import { useMediaQuery } from "react-responsive";
import { apiLabelUrl, getCurrentLabel } from "./Functions/functions";
import EmbeddedLoginPoller, { isEmbedded } from "./EmbeddedLoginPoller";

export default function Login(props) {
    const { language, labelLogo, setLabelLogo } = useGlobalState();
    const [formButton, setFormButton] = useState(null);
    const [created, setCreated] = useState(false);
    const [loginForm, setLoginForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [handleLogin, setHandleLogin] = useState(false);
    const [pendingLogin, setPendingLogin] = useState(null);
    const [featuredCasesFirstColumn, setFeaturedCasesFirstColumn] = useState({});
    const [featuredCasesSecondColumn, setFeaturedCasesSecondColumn] = useState({});
    const [loginContent, setLoginContent] = useState({});
    const [activeCase, setActiveCase] = useState(0);
    const [activeCase2, setActiveCase2] = useState(0);
    const [playVideo, setPlayVideo] = useState(false);
    const isResponsive = useMediaQuery({ query: "(max-width: 1056px)" });
    const [pageTitle, setPageTitle] = useState("");

    useEffect(() => {
        axios.get(window.location.origin + "/api/which-label").then(function (response) {
            if (response.data.object.login_page_title) {
                setPageTitle(response.data.object.login_page_title);
            }
        });
    }, [props.textData]);

    useEffect(() => {
        const fetchFeaturedCases = async () => {
            try {
                const response = await axios.get((await apiLabelUrl("api")) + "/featured-cases");

                // slice
                const firstColumnData = response.data["featuredCases"].slice(
                    0,
                    Math.ceil(response.data["featuredCases"].length / 2)
                );
                const secondColumnData = response.data["featuredCases"].slice(
                    Math.ceil(response.data["featuredCases"].length / 2)
                );
                console.log("firstColumnData", firstColumnData);
                console.log("secondColumnData", secondColumnData);
                setFeaturedCasesFirstColumn(firstColumnData);
                setFeaturedCasesSecondColumn(secondColumnData);
            } catch (error) {
                console.error(error);
            }
        };
        fetchFeaturedCases();
        const fetchLoginContent = async () => {
            try {
                const response = await axios.get((await apiLabelUrl("api")) + "/login-content");
                setLoginContent(response.data["loginContent"]);
                setLabelLogo(response.data["labelLogo"]);
            } catch (error) {
                console.error(error);
            }
        };
        fetchLoginContent();
    }, []);

    useEffect(() => {
        if (!!props.textData && !formButton) {
            if (!loginForm) {
                const saveQuotationBtnData = {
                    name: "save-quotation",
                    className: "save-quotation-btn",
                    icon: "save-quotation-icon",
                    text: props.textData["request_btn"],
                    type: "submit",
                };
                setFormButton(saveQuotationBtnData);
            }
        }
    }, [props.textData, loginForm]);

    const extractFirstNameAndLastName = (fullName) => {
        const [firstName, ...lastNameArray] = fullName.trim().split(" ");
        const lastName = lastNameArray.join(" ");

        return {
            firstName,
            lastName,
        };
    };

    const getCharactersFromString = (str, whiteSpaceIndex = str.indexOf(" ")) => {
        let characters = str.match(/[a-zA-Z]/g);
        characters.splice(whiteSpaceIndex, 0, " ");
        return characters ? characters.join("") : "";
    };

    const getNumbersFromString = (str) => {
        let numbers = str.match(/\d+/g);
        return numbers ? numbers.join("") : "";
    };

    const handleLoginSection = () => {
        setLoginForm(true);
        setErrorMessage({});
    };

    const handleLoginExpired = () => {
        setPendingLogin(null);
        setHandleLogin(false);
        setErrorMessage(["The login link has expired. Please request a new one."]);
    };

    const formikLoginUserFormHandler = useFormik({
        initialValues: {
            email: "",
        },
        onSubmit: (values) => {
            const loginFormData = new FormData();
            loginFormData.append("email", values["email"]);
            if (isEmbedded()) {
                loginFormData.append("embedded", "1");
            }

            axios
                .post(window.location.origin + "/api/login", loginFormData)
                .then(function (response) {
                    setHandleLogin(true);
                    setPendingLogin(response.data.pending || null);
                    localStorage.removeItem("registration-email");
                })
                .catch(function (error) {
                    setErrorMessage([props.textData["popups/login"]["error_message"]]);
                    localStorage.setItem("registration-email", values["email"]);
                });
        },
    });

    const handleNextCase = (event, column = "first") => {
        let totalCases = Object.keys(featuredCasesFirstColumn).length;
        if (column === "second") {
            totalCases = Object.keys(featuredCasesSecondColumn).length;
        }

        console.log("totalCases", column);

        if (totalCases <= 0) {
            return;
        }
        const eventAction = event.target.dataset.action;
        if (column === "first") {
            setActiveCase((prevActiveCase) => {
                if (eventAction === "previous") {
                    return (prevActiveCase - 1 + totalCases) % totalCases;
                } else if (eventAction === "next") {
                    return (prevActiveCase + 1) % totalCases;
                }
            });
        } else {
            setActiveCase2((prevActiveCase) => {
                if (eventAction === "previous") {
                    return (prevActiveCase - 1 + totalCases) % totalCases;
                } else if (eventAction === "next") {
                    return (prevActiveCase + 1) % totalCases;
                }
            });
        }
    };

    return (
        <>
            {featuredCasesFirstColumn !== undefined &&
                !!Object.keys(featuredCasesFirstColumn).length &&
                !!Object.keys(loginContent).length &&
                !!language && (
                    <>
                        {!isResponsive ? (
                            <div className="login-container">
                                <div className="login-header">
                                    {/* <img src={labelLogo.url} className="logo" alt="logo" />
                                    <a href={httpOrHttps + loginContent["contact_name"][language]}>
                                        <div className="navigation-link">
                                            <div className="icon-container">
                                                <FontAwesomeIcon icon={faGlobe} size="xs" />
                                            </div>
                                            <p className="navi-text">Naar {loginContent["contact_name"][language]}</p>
                                        </div>
                                    </a> */}
                                </div>
                                <div className="case-grid">
                                    <div
                                        className="case-container"
                                        style={{
                                            backgroundImage: `url(${featuredCasesFirstColumn[activeCase].image[language]})`,
                                        }}
                                    >
                                        <div className="case-card">
                                            {/* <div className="card-arrows">
                                                <span
                                                    onClick={(e) => handleNextCase(e)}
                                                    className="arrow-left"
                                                    data-action="previous"
                                                ></span>
                                                <span
                                                    onClick={(e) => handleNextCase(e)}
                                                    className="arrow-right"
                                                    data-action="next"
                                                ></span>
                                            </div> */}
                                            <div className="card-header">
                                                <h2 className="title">
                                                    {featuredCasesFirstColumn[activeCase].title[language]}
                                                </h2>
                                                <p className="description">
                                                    {featuredCasesFirstColumn[activeCase].description[language]}
                                                </p>
                                            </div>
                                            <div className="card-body">
                                                <a
                                                    href={featuredCasesFirstColumn[activeCase]["case_link"]}
                                                    target="_blank"
                                                >
                                                    <div className="case-label">
                                                        <p className="subtitle">
                                                            {
                                                                featuredCasesFirstColumn[activeCase]["case_subtitle"][
                                                                    language
                                                                ]
                                                            }
                                                        </p>
                                                        <h4 className="title">
                                                            {
                                                                featuredCasesFirstColumn[activeCase]["case_title"][
                                                                    language
                                                                ]
                                                            }
                                                        </h4>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="case-container"
                                        style={{
                                            backgroundImage: `url(${featuredCasesSecondColumn[activeCase2].image[language]})`,
                                        }}
                                    >
                                        <div className="case-card">
                                            {/* <div className="card-arrows">
                                                <span
                                                    onClick={(e) => handleNextCase(e, "second")}
                                                    className="arrow-left"
                                                    data-action="previous"
                                                ></span>
                                                <span
                                                    onClick={(e) => handleNextCase(e, "second")}
                                                    className="arrow-right"
                                                    data-action="next"
                                                ></span>
                                            </div> */}
                                            <div className="card-header">
                                                <h2 className="title">
                                                    {featuredCasesSecondColumn[activeCase2].title[language]}
                                                </h2>
                                                <p className="description">
                                                    {featuredCasesSecondColumn[activeCase2].description[language]}
                                                </p>
                                            </div>
                                            <div className="card-body">
                                                <a
                                                    href={featuredCasesSecondColumn[activeCase2]["case_link"]}
                                                    target="_blank"
                                                >
                                                    <div className="case-label">
                                                        <p className="subtitle">
                                                            {
                                                                featuredCasesSecondColumn[activeCase2]["case_subtitle"][
                                                                    language
                                                                ]
                                                            }
                                                        </p>
                                                        <h4 className="title">
                                                            {
                                                                featuredCasesSecondColumn[activeCase2]["case_title"][
                                                                    language
                                                                ]
                                                            }
                                                        </h4>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="interaction">
                                        <div className="login-component">
                                            {!created ? (
                                                <>
                                                    <h1>{pageTitle}</h1>
                                                    <div className="header">
                                                        {!handleLogin ? (
                                                            <>
                                                                <div className="description">
                                                                    {props.textData["popups/login"]["subtitle"]}
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="description">
                                                                    {props.textData["popups/login"]["success_message"]}
                                                                </div>
                                                                {pendingLogin && <EmbeddedLoginPoller pending={pendingLogin} onExpired={handleLoginExpired} />}
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="content">
                                                        {!handleLogin && (
                                                            <>
                                                                <div className="content-header">
                                                                    <div className="title">
                                                                        {
                                                                            props.textData["popups/login"][
                                                                                "account_login_title"
                                                                            ]
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="content-body">
                                                                    <LoginUserForm
                                                                        formik={formikLoginUserFormHandler}
                                                                        errorMessage={errorMessage}
                                                                        textData={props.textData["popups/login"]}
                                                                        formButton={{
                                                                            name: "save-quotation",
                                                                            className: "save-quotation-btn",
                                                                            icon: "save-quotation-icon",
                                                                            text: props.textData["popups/login"][
                                                                                "login_btn"
                                                                            ],
                                                                            type: "submit",
                                                                        }}
                                                                        registerButton={{
                                                                            name: props.textData["popups/login"][
                                                                                "register_btn"
                                                                            ],
                                                                            path: props.textData["urls/register"][
                                                                                "unique_name"
                                                                            ],
                                                                        }}
                                                                        navigateToPageName={props.navigateToPageName}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="header">
                                                        {/*@TODO: add translation fields instead of hardcoded text */}
                                                        <div className="title">
                                                            {props.textData["popups/login"]["account_created"]}
                                                        </div>
                                                        <div className="description">
                                                            {props.textData["popups/login"]["check_email_to_login"]}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div className="contact-card">
                                            {!!loginContent["contact_name"][language] &&
                                            !!loginContent["contact_subtitle"][language] ? (
                                                <>
                                                    <div className="card-header">
                                                        <p className="description">
                                                            {loginContent["contact_text"][language]}
                                                        </p>
                                                    </div>
                                                    <div className="card-body">
                                                        <a
                                                            href={loginContent["contact_link"][language]}
                                                            target="_blank"
                                                        >
                                                            <div className="case-label">
                                                                <img
                                                                    className="contact-thumbnail"
                                                                    src={`${window.location.origin}/storage/${loginContent["contact_image"][language]}`}
                                                                />
                                                                <div className="contact-info">
                                                                    <p className="subtitle">
                                                                        {loginContent["contact_subtitle"][language]}
                                                                    </p>
                                                                    <h4 className="title">
                                                                        {loginContent["contact_name"][language]}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <a href={loginContent["contact_link"][language]} target="_blank">
                                                        <img src={labelLogo?.url} className="logo" alt="logo" />
                                                    </a>
                                                    <button
                                                        onClick={() => {
                                                            window.location.replace(
                                                                pageTitle.includes("3DMM") ||
                                                                    pageTitle.includes("3dmm") ||
                                                                    pageTitle.includes("medical")
                                                                    ? "https://3dmedicalmodels.nl/"
                                                                    : "https://www.oceanz.eu/en/"
                                                            );
                                                        }}
                                                        className="temp-btn"
                                                    >
                                                        Visit our website
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        <div className="video">
                                            {/* <div className="player-wrapper">
                                                    <a
                                                        onClick={() => {
                                                            if (!playVideo) {
                                                                setPlayVideo(true);
                                                            }
                                                        }}
                                                        href="#"
                                                        className={`play-button ${playVideo === true ? "hidden" : ""}`}
                                                    ></a>
                                                    <ReactPlayer
                                                        url={`${window.location.origin}/storage/${loginContent["video_file"]}`}
                                                        className="react-player"
                                                        width="100%"
                                                        height="auto"
                                                        playing={playVideo}
                                                        loop={true}
                                                        controls={playVideo}
                                                        onPlay={() => {
                                                            setPlayVideo(true);
                                                        }}
                                                        onPause={() => {
                                                            setPlayVideo(false);
                                                        }}
                                                    />
                                                </div> */}
                                            <div className="content">
                                                <h1 className="title">{loginContent["video_title"][language] ?? ""}</h1>
                                                {parse(loginContent["video_content"][language] ?? "")}
                                            </div>
                                        </div>
                                        {loginContent &&
                                            loginContent["iban"] &&
                                            loginContent["cc"] &&
                                            loginContent["vat"] && (
                                                <div className="video">
                                                    <div className="company-content">
                                                        <h1>Company information</h1>
                                                        <div className="company-info-list">
                                                            <p>
                                                                <strong>IBAN:</strong>{" "}
                                                                <span>{loginContent["iban"]}</span>
                                                            </p>
                                                            <p>
                                                                <strong>CC:</strong> <span>{loginContent["cc"]}</span>
                                                            </p>
                                                            <p>
                                                                <strong>VAT:</strong> <span>{loginContent["vat"]}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="mobile-container">
                                <div className="login-header">
                                    {/* <img src={labelLogo?.url} className="logo" alt="logo" /> */}
                                    {/*@TODO: Fix hardcoded href */}
                                    {/* <a href={httpOrHttps + loginContent["contact_name"][language]}>
                                        <div className="navigation-link">
                                            <div className="icon-container">
                                                <FontAwesomeIcon icon={faGlobe} size="xs" />
                                            </div>
                                            <p className="navi-text">Naar {loginContent["contact_name"][language]}</p>
                                        </div>
                                    </a>*/}
                                </div>
                                <div className="login-component">
                                    {!created ? (
                                        <>
                                            <h1>{props.textData["popups/login"]["title"]}</h1>
                                            <div className="header">
                                                {!handleLogin ? (
                                                    <>
                                                        <div className="description">
                                                            {props.textData["popups/login"]["subtitle"]}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="description">
                                                            {props.textData["popups/login"]["success_message"]}
                                                        </div>
                                                        {pendingLogin && <EmbeddedLoginPoller pending={pendingLogin} onExpired={handleLoginExpired} />}
                                                    </>
                                                )}
                                            </div>
                                            <div className="content">
                                                {!handleLogin && (
                                                    <>
                                                        <div className="content-header">
                                                            <div className="title">
                                                                {props.textData["popups/login"]["account_login_title"]}
                                                            </div>
                                                        </div>
                                                        <div className="content-body">
                                                            <LoginUserForm
                                                                formik={formikLoginUserFormHandler}
                                                                errorMessage={errorMessage}
                                                                textData={props.textData["popups/login"]}
                                                                formButton={{
                                                                    name: "save-quotation",
                                                                    className: "save-quotation-btn",
                                                                    icon: "save-quotation-icon",
                                                                    text: props.textData["popups/login"]["login_btn"],
                                                                    type: "submit",
                                                                }}
                                                                registerButton={{
                                                                    name: props.textData["popups/login"][
                                                                        "register_btn"
                                                                    ],
                                                                    path: props.textData["urls/register"][
                                                                        "unique_name"
                                                                    ],
                                                                }}
                                                                navigateToPageName={props.navigateToPageName}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="header">
                                                {/*@TODO: add translation fields instead of hardcoded text */}
                                                <div className="title">
                                                    {props.textData["popups/login"]["account_created"]}
                                                </div>
                                                <div className="description">
                                                    {props.textData["popups/login"]["check_email_to_login"]}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="contact-card">
                                    {!!loginContent["contact_name"][language] &&
                                    !!loginContent["contact_subtitle"][language] ? (
                                        <>
                                            <div className="card-header">
                                                <p className="description">{loginContent["contact_text"][language]}</p>
                                            </div>
                                            <div className="card-body">
                                                <a href={loginContent["contact_link"][language]} target="_blank">
                                                    <div className="case-label">
                                                        <img
                                                            className="contact-thumbnail"
                                                            src={`${window.location.origin}/storage/${loginContent["contact_image"][language]}`}
                                                        />
                                                        <div className="contact-info">
                                                            <p className="subtitle">
                                                                {loginContent["contact_subtitle"][language]}
                                                            </p>
                                                            <h4 className="title">
                                                                {loginContent["contact_name"][language]}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <a href={loginContent["contact_link"][language]} target="_blank">
                                                <img src={labelLogo?.url} className="logo" alt="logo" />
                                            </a>
                                            <button
                                                onClick={() => {
                                                    window.location.replace(
                                                        "https://www.oceanz.eu/your-oceanz-is-vernieuwd/"
                                                    );
                                                }}
                                                className="temp-btn"
                                            >
                                                Your Oceanz is vernieuwd
                                            </button>
                                        </>
                                    )}
                                </div>
                                <div className="cases-container">
                                    <div
                                        className="case-container"
                                        style={{
                                            backgroundImage: `url(${featuredCasesSecondColumn[activeCase2].image[language]})`,
                                        }}
                                    >
                                        <div className="case-card">
                                            {/* <div className="card-arrows">
                                                <span
                                                    onClick={(e) => handleNextCase(e, "second")}
                                                    className="arrow-left"
                                                    data-action="previous"
                                                ></span>
                                                <span
                                                    onClick={(e) => handleNextCase(e, "second")}
                                                    className="arrow-right"
                                                    data-action="next"
                                                ></span>
                                            </div> */}
                                            <div className="card-header">
                                                <h2 className="title">
                                                    {featuredCasesSecondColumn[activeCase2].title[language]}
                                                </h2>
                                                <p className="description">
                                                    {featuredCasesSecondColumn[activeCase2].description[language]}
                                                </p>
                                            </div>
                                            <div className="card-body">
                                                <a
                                                    href={featuredCasesSecondColumn[activeCase2]["case_link"]}
                                                    target="_blank"
                                                >
                                                    <div className="case-label">
                                                        <p className="subtitle">
                                                            {
                                                                featuredCasesSecondColumn[activeCase2]["case_subtitle"][
                                                                    language
                                                                ]
                                                            }
                                                        </p>
                                                        <h4 className="title">
                                                            {
                                                                featuredCasesSecondColumn[activeCase2]["case_title"][
                                                                    language
                                                                ]
                                                            }
                                                        </h4>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="video">
                                    {/* <div className="player-wrapper">
                                        <a
                                            onClick={() => {
                                                if (!playVideo) {
                                                    setPlayVideo(true);
                                                }
                                            }}
                                            href="#"
                                            className={`play-button ${playVideo === true ? "hidden" : ""}`}
                                        ></a>
                                        <ReactPlayer
                                            url={`${window.location.origin}/storage/${loginContent["video_file"]}`}
                                            className="react-player"
                                            width="100%"
                                            height="auto"
                                            playing={playVideo}
                                            loop={true}
                                            controls={playVideo}
                                            onPlay={() => {
                                                setPlayVideo(true);
                                            }}
                                            onPause={() => {
                                                setPlayVideo(false);
                                            }}
                                        />
                                    </div> */}
                                    <div className="content">
                                        <h1 className="title">{loginContent["video_title"][language] ?? ""}</h1>
                                        {parse(loginContent["video_content"][language] ?? "")}
                                    </div>
                                </div>
                                {loginContent && loginContent["iban"] && loginContent["cc"] && loginContent["vat"] && (
                                    <div className="video">
                                        <div className="company-content">
                                            <h1>Company information</h1>
                                            <div className="company-info-list">
                                                <p>
                                                    <strong>IBAN:</strong> <span>{loginContent["iban"]}</span>
                                                </p>
                                                <p>
                                                    <strong>CC:</strong> <span>{loginContent["cc"]}</span>
                                                </p>
                                                <p>
                                                    <strong>VAT:</strong> <span>{loginContent["vat"]}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
        </>
    );
}
